import { Component, OnInit} from '@angular/core';
import { Alerts } from './alerts';
import { AlertsService } from './alerts.service';

@Component({
    selector: 'app-alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.less']
})
export class AlertsComponent implements OnInit
{
    hasAlerts = false;
    alerts: Alerts[];
    showAlertsList = false;
    alertBannerText = '';
    isCriticalAlert = false;

    constructor(private alertsService: AlertsService) { }

    ngOnInit()
    {
        this.alertsService.criticalAlertSent
            .subscribe((message: string) =>
            {
                this.alertBannerText = message;
                this.isCriticalAlert = true;
                this.hasAlerts = true;
            });

        this.alertsService.criticalAlertCleared
            .subscribe(() =>
            {
                this.alertBannerText = '';
                this.isCriticalAlert = false;
                this.hasAlerts = false;
            });
        this.alertBannerText = 'Some Random Alert with some random text description. Lorem Ipsum is simply dummy text of the printing and typesetting industry.';
    }

    protected closeAlerts()
    {
        this.hasAlerts = false;
    }

    protected toggleAlertsList()
    {
        this.showAlertsList = !this.showAlertsList;
    }

    protected eatClick(e: Event)
    {
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
    }
}
